import React from 'react';
import { FormattedMessage } from "react-intl"

const Option = ({ value, options, onClick, ...props }) => {

    const handleClick = () => {
        onClick(value);
    }

    const isSelected = () => {
        return options.some(opt => opt === value);
    }

    return (
        <div onClick={handleClick} className={`${isSelected() ? 'bg-gray-500 text-white hover:bg-gray-400 hover:text-white' : 'bg-gray-200 hover:text-green-900'}  p-1 rounded-full font-medium cursor-pointer `}>
            {props.children}
        </div>
    );
}


const CategorySelect = ({ onChange, values, selectError }) => {

    const handleToggle = (value) => {
        // console.log('clicked value');
        // console.log(value);
        if (values.some(opt => opt === value)) {
            onChange(values.filter(opt => opt !== value))
        } else {
            onChange([...values, value]);
        }
    }

    return (
        <div>
            <div className="mb-2 mt-2  text-center">
                <div className="flex flex-row text-center">
                    <FormattedMessage id="app.register.selectBusinessCategory" defaultMessage="Select at least one application:" />
                    <h1 className='text-red-600'> *</h1>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 p-2 justify-between gap-2 text-center text-xs md:text-md">
                <Option value={1} onClick={handleToggle} options={values}><FormattedMessage id="app.categories.footwear" defaultMessage="Footwear" /></Option>
                <Option value={2} onClick={handleToggle} options={values}><FormattedMessage id="app.categories.leather" defaultMessage="Leather" /></Option>
                <Option value={3} onClick={handleToggle} options={values}><FormattedMessage id="app.categories.upholstery" defaultMessage="Furniture" /></Option>
                <Option value={4} onClick={handleToggle} options={values}><FormattedMessage id="app.categories.transportation" defaultMessage="Transportation" /></Option>
            </div>
            {selectError && <div className="text-yellow-700">Seleziona almeno un settore</div>}
        </div>
    );
};

export default CategorySelect;